import { Trans } from '@lingui/react/macro';

const SIZES = {
  small: 'S',
  medium: 'M',
  large: 'L',
  xl: 'XL',
  xxl: 'XXL',
  xxxl: 'XXXL',
};
const getSize = (size, w, l) => ({ size, w, l });

const sizeChartData = [
  {
    title: <Trans>Mens Shirts</Trans>,
    eventKey: 'men',
    sizes: [
      getSize(SIZES.small, 45.8, 71.2),
      getSize(SIZES.medium, 50.8, 73.7),
      getSize(SIZES.large, 55.9, 76.2),
      getSize(SIZES.xl, 61, 78.8),
      getSize(SIZES.xxl, 66.1, 81.3),
      getSize(SIZES.xxxl, 71.1, 83.8),
    ],
  },
  {
    title: <Trans>Women Shirts</Trans>,
    eventKey: 'women',
    sizes: [
      getSize(SIZES.small, 43.2, 63.5),
      getSize(SIZES.medium, 45.8, 66.1),
      getSize(SIZES.large, 49.6, 68.6),
      getSize(SIZES.xl, 52.1, 70.5),
      getSize(SIZES.xxl, 58.5, 71.2),
    ],
  },
  {
    title: <Trans>Kids Shirts</Trans>,
    eventKey: 'kids',
    sizes: [
      getSize(SIZES.medium, 43.2, 55.9),
      getSize(SIZES.large, 45.8, 59.7),
      getSize(SIZES.xl, 48.3, 63.5),
    ],
  },
  {
    title: <Trans>Hoodies</Trans>,
    eventKey: 'hoodies',
    sizes: [
      getSize(SIZES.small, 51, 67),
      getSize(SIZES.medium, 56, 70),
      getSize(SIZES.large, 61, 73),
      getSize(SIZES.xl, 65, 76),
      getSize(SIZES.xxl, 69, 79),
    ],
  },
  {
    title: <Trans>Sweaters</Trans>,
    eventKey: 'sweaters',
    sizes: [
      getSize(SIZES.small, 52, 68),
      getSize(SIZES.medium, 56, 71),
      getSize(SIZES.large, 60, 74),
      getSize(SIZES.xl, 64, 77),
      getSize(SIZES.xxl, 68, 80),
    ],
  },
  {
    title: <Trans>Pullovers</Trans>,
    eventKey: 'pullovers',
    sizes: [
      getSize(SIZES.small, 50.8, 68.6),
      getSize(SIZES.medium, 55.9, 71.2),
      getSize(SIZES.large, 61, 73.7),
      getSize(SIZES.xl, 66.1, 76.2),
      getSize(SIZES.xxl, 71.2, 78.8),
    ],
  },
];

export default sizeChartData;
